<template>
  <div class="details-component" v-if="permits.items">
    <div class="details-component__header">
      <h1 class="header">{{ $tc('common.permit', permits.total) }}</h1>
      <switch-checkbox
        :text="$t('permits.hide_permits')"
        :onChange="toggleHidePermits"
        :checked="isHidePermits"
        :disabled="isDisabledSwitchCheckbox"
        v-if="permits.items.length > 0"
      />
    </div>
    <div class="end-user">
      <Sidebar :checkedHidePermits="isHidePermits"/>
      <!--TODO HENRI show edit form only when selected / fix 2x MainView mounting -->
      <EditViewPermit v-if="permits.items.length > 0" :fetchPermits="fetchPermits"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import SwitchCheckbox from 'common/SwitchCheckbox';
import EditViewPermit from './EditViewPermit';
import Sidebar from './Sidebar';

export default {
  components: {
    Sidebar,
    EditViewPermit,
    SwitchCheckbox,
  },
  data() {
    return {
      isHidePermits: false,
      isDisabledSwitchCheckbox: true,
    };
  },
  computed: mapGetters({
    user: 'user/user/user',
    permits: 'landlord/permits/permits',
  }),
  created() {
    this.fetchPermits();
  },
  methods: {
    fetchPermits(isInitialRequest = true) {
      if (this.user.data) {
        this.$store.dispatch('landlord/permits/fetch', { user: this.user, limit: 2000 }).then(() => {
          if (this.permits && this.permits.items && this.permits.items.length > 0) {
            this.permits.items.sort((a, b) => this.dynamicSort('id', a, b)).filter(() => true);
            if(isInitialRequest){
              this.permits.items.forEach((item) => {
                if (moment().isAfter(moment(item.expirationDate, 'DD.MM.YYYY'), 'day')) {
                  this.isDisabledSwitchCheckbox = false;
                }
              });
              if (!(this.$children && this.$children[1] && this.$children[1].isPermitSelected)) {
                /* TODO HENRI show edit form only when selected / fix 2x MainView mounting */
                this.$router.push({ name: 'user-permit', params: { id: this.permits.items[0].id } });
              }
            }
          }
        });
      }
    },
    dynamicSort(property, a, b) {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    },
    toggleHidePermits(isChecked) {
      this.isHidePermits = isChecked;
    },
  },
};
</script>
<style scoped lang="scss">
.end-user {
  display: flex;

  > div:first-child {

    @media screen and (max-width: 760px) {
      width: 100%;
    }

  }

  /*@media screen and (max-width: 1074px) { /* 1024px */
   /*flex-direction: column;

   .user-details-container {
     margin: 0;
   }*/
  /*}*/
}
.details-component__header {
  justify-content: flex-start;
  @media screen and (max-width: 520px) {
    height: auto;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
}
.header {
  margin-right: 20px;
  @media screen and (max-width: 520px) {
    margin: 20px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/Permits.vue